import Swiper from 'swiper/js/swiper.min';

export default function createSliderHeader(swiperContainer) {
  const slides = document.querySelectorAll('.swiper-slide');
  if (slides.length > 1 && !swiperContainer.classList.contains('initialized')) {
    swiperContainer.classList.add('initialized');
    swiperContainer.classList.remove('carousel-off');
    let slidesPerView = 1;
    if (swiperContainer.getAttribute('slides')) {
      slidesPerView = swiperContainer.getAttribute('slides');
    }
    const swiperOptions = {
      direction: 'horizontal',
      slidesPerView,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Vorheriger Slide',
        nextSlideMessage: 'Nächster Slide',
        paginationBulletMessage: 'Gehe zum Slide {{index}}',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      loop: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    };
    const autoplayInterval = swiperContainer.getAttribute('data-interval');
    if (autoplayInterval && autoplayInterval > 1000) {
      swiperOptions.autoplay = {
        delay: autoplayInterval,
        disableOnInteraction: false,
      };
    }
    return new Swiper(swiperContainer, swiperOptions);
  }
  return null;
}
